import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from "xlsx";

@Component({
  selector: 'app-reg-on-block',
  templateUrl: './reg-on-block.component.html',
  styleUrls: ['./reg-on-block.component.css']
})
export class RegOnBlockComponent implements OnInit {

  public menu_item_id = '119';
  public add_auth;
  public edit_auth;
  public del_auth;

  invoice_detail = { 'invoice_no': '', 'flight_id': '' };
  agent_detail = { 'acct_number': '' };
  return_flight = { 'flight_id': '', 'flight_name': '', 'flight_date': '' };

  traveler_list = [];
  saveClicked = false;

  group_model = {
    'table_name': 'trip_group', 'group_id': '0', 'invoice_no': '', 'head_id': '', 'member_id': '',
    'member_head_relation': '', 'is_active': '1', 'group_type': '', 'trip_arrival_date': '', 'trip_depart_date': '',
    'eticket': '', 'ticket_status': '0', 'ticket_count': '0', 'bed_count': '0', 'price': '0', 'room_type_id': '',
    'flag': 'new', 'key': 'group_id', 'comment': '', 'member_age': '-1'
  };

  customer_model = {
    'table_name': 'customer', 'customer_id': '0', 'customer_name': '', 'customer_name_en': '', 
    'customer_last_name': '', 'acct_number': '', 'national_id': '0', 'customer_category_id': '0', 
    'tax_no': '', 'city_id': '0', 'address': '', 'mobile': '', 'phone1': '', 'phone2': '', 'fax': '', 
    'email': '', 'represent1': '', 'represent1_mobile': '', 'represent2': '',
    'represent2_mobile': '', 'def_rep_no': '0', 'claim_day': 0, 'comment': '', 'car_type': '',
    'key': 'customer_id', 'flag': 'new', 'car_model': '', 'car_color': '', 'is_account': '1',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'customer_cr': ''
  };

  traveler_model = {
    'table_name': 'traveler_info', 'info_id': '0', 'acct_number': '', 'date_of_birth': '', 'gender': 'm',
    'occupation': '', 'passport_no': '', 'passport_issue_date': '', 'passport_issue_location': '',
    'key': 'info_id', 'flag': 'new', 'passport_expiry_date': '', 'smoker': 'false', 'medical_care': 'false',
    'nationality': '', 'passport_type': '', 'passport_attach': '', 'comment': '',
    'reference': ''
  };

  base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'base_date': '', 'acct_number': '',
    'main_acct_no': this.applicationConstants.main_acct_config['customer'],
    'acct_type_no': this.applicationConstants.acct_type_config['customer'], 'key': 'baseline_id',
    'flag': 'new', 'baseline_amount': '0', 'comment': ''
  };

  sub_acct_model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0',
    'acct_type_no': this.applicationConstants.acct_type_config['customer'],
    'main_acct_no': this.applicationConstants.main_acct_config['customer'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct': this.applicationConstants.main_acct_config['customer'],
    'acct_level': '1', 'is_leaf': '1', 'is_cc': '1', 'tax_acct': '0', 'emp_no': '0', 'cc_no': '0',
    'key': 'sub_acct_id', 'flag': 'new', 'comment': '', 'auto_set': '0', 'set_type': 'count'
  };

  No_Traveler_Msg2; Flight_Avail_Seat_Msg; Trav_Exist_Msg; Traveler_No; Mobile;
  Success_Msg; Error_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public translate: TranslateService, private route: ActivatedRoute, private router: Router) { 
      this.getMessages(translate);
    }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('No_Traveler_Msg2').subscribe((res: string) => {
      this.No_Traveler_Msg2 = res;
    });
    
    translate.get('Flight_Avail_Seat_Msg').subscribe((res: string) => {
      this.Flight_Avail_Seat_Msg = res;
    });

    translate.get('Trav_Exist_Msg').subscribe((res: string) => {
      this.Trav_Exist_Msg = res;
    });
    
    translate.get('Traveler_No').subscribe((res: string) => {
      this.Traveler_No = res;
    });
    
    translate.get('Mobile').subscribe((res: string) => {
      this.Mobile = res;
    });
    
    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });
    
    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    // get invoice and flights details
    this.route.params.subscribe(params => {
      this.invoice_detail['invoice_no'] = params['no'];
      let query, obj;

      // get invoice and depart flight details
      query = "SELECT * FROM `invoice`, `flight` WHERE `invoice`.`invoice_no` = '" + 
        this.invoice_detail['invoice_no'] + "' AND `invoice`.`flight_id` = `flight`.`flight_id`";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.invoice_detail = data.data['list'][0];

          // get the reserved ticket
          query = "SELECT COALESCE(COUNT(`group_id`), 0) AS `registered_count` FROM `trip_group` WHERE `invoice_no` = '" + 
            this.invoice_detail['invoice_no'] + "' AND `head_id` != `member_id` AND `member_age` >= 2";
          obj = { cmd: 'getList', query: query };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              this.invoice_detail['registered_count'] = data.data['list'][0]['registered_count'];
              this.invoice_detail['available_count'] = Number(this.invoice_detail['pass_count']) - Number(this.invoice_detail['registered_count']);
              console.log(this.invoice_detail['registered_count']);
              console.log(this.invoice_detail['available_count']);
            });
        });

      // get agent detail
      query = "SELECT `customer`.* FROM `invoice`, `customer` WHERE `invoice`.`invoice_no` = '" + 
        this.invoice_detail['invoice_no'] + "' AND `invoice`.`customer_no` = `customer`.`acct_number`";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0)
            this.agent_detail = data.data['list'][0];
        });

      // get depart flight detail
      // query = "SELECT * FROM `flight` WHERE `flight_id` = '" + this.depart_flight['flight_id'] + "'";
      // obj = { cmd: 'getList', query: query };
      // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      //   .subscribe(data => {
      //     this.applicationConstants.appComp.hideBusyCursor();

      //     if (data.data['list'].length > 0)
      //       this.depart_flight = data.data['list'][0];
      //   });

      // get return flight detail
      query = "SELECT * FROM `reg_on_ticket` WHERE `invoice_no` = '" + this.invoice_detail['invoice_no'] + "'";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            let return_flight_id = data.data['list'][0]['return_flight_id'];

            if (return_flight_id != "0") {

              query = "SELECT * FROM `flight` WHERE `flight_id` = '" + return_flight_id + "'";
              obj = { cmd: 'getList', query: query };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.data['list'].length > 0)
                    this.return_flight = data.data['list'][0];
                });
            }
          }
        });
    });
  }

  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length > 1) {
      alert('Multiple files are not allowed');
      return;
    }
    else {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        this.traveler_list = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
        // Print the Excel Data
        console.log(this.traveler_list);
        console.log(this.traveler_list.length);
      }
      reader.readAsBinaryString(target.files[0]);
    }
  }

  regOnBlock() {
    this.saveClicked = true;

    if (this.traveler_list.length == 1) {
      alert(this.No_Traveler_Msg2);
      this.saveClicked = false;
      return;
    }

    if (this.traveler_list.length - 1 > Number(this.invoice_detail['available_count'])) {
      alert(this.Flight_Avail_Seat_Msg);
      this.saveClicked = false;
      return;
    }

    let query, obj;
    let alertMsg = "";

    for (let index = 1; index < this.traveler_list.length; index++) {

      this.traveler_model['date_of_birth'] = (this.traveler_list[index][4] != '' ? this.traveler_list[index][4] : '1990-01-01');

      query = "SELECT `traveler_info`.`acct_number`, `customer`.`mobile` FROM `traveler_info`, `customer` " + 
        "WHERE `traveler_info`.`status` = '1' AND `traveler_info`.`date_of_birth` = '" + 
        this.traveler_model['date_of_birth'] + "' AND `traveler_info`.`passport_no` = '" + 
        this.traveler_list[index][6] + "' AND `traveler_info`.`acct_number` = `customer`.`acct_number`";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.data['list'].length != 0) {
          let travelerInfo = data.data['list'][0];

          if (alertMsg != "")
            alertMsg + " ";

          alertMsg += this.Trav_Exist_Msg + ", " + this.Traveler_No + ": " + travelerInfo.acct_number + ", " + 
            this.Mobile + ": " + travelerInfo.mobile + ".";
        }

        if (index + 1 == this.traveler_list.length) {
          if (alertMsg == "") 
            this.saveTraveler();
          else {
            alert(alertMsg);
            this.saveClicked = false;
          }
        }
      });
    }

    // this.traveler_list.forEach(element => {

    //   date_of_birth = (element[4] != '' ? element[4] : '1990-01-01');

    //   query = "SELECT `traveler_info`.`acct_number`, `customer`.`mobile` FROM `traveler_info`, `customer` " + 
    //     "WHERE `traveler_info`.`status` = '1' AND `traveler_info`.`date_of_birth` = '" + 
    //     date_of_birth + "' AND `traveler_info`.`passport_no` = '" + 
    //     element[6] + "' AND `traveler_info`.`acct_number` = `customer`.`acct_number`";
    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();

    //     if (data.data['list'].length == 0) {
    //       // add the traveler

    //       // generate acct number for traveler
    //       query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
    //         this.sub_acct_model['parent_acct'] + "'";
    //       obj = { cmd: 'getList', query: query };

    //       this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //         .subscribe(data => {
    //           this.applicationConstants.appComp.hideBusyCursor();

    //           let result = data.data['list'][0]['acct_number'];
    //           if (result == '0')
    //             this.customer_model['acct_number'] = this.sub_acct_model['parent_acct'] + "001";
    //           else {
    //             if (result.indexOf(this.sub_acct_model['parent_acct']) != -1) {
    //               result = result.substring(result.indexOf(this.sub_acct_model['parent_acct']) + (this.sub_acct_model['parent_acct']).length);
    //               console.log('result: ' + result);
    //               result = String(Number(result) + 1);
    //               if (Number(result) < 10)
    //                 result = '00' + result;
    //               else if (Number(result) < 100)
    //                 result = '0' + result;

    //               this.customer_model['acct_number'] = this.sub_acct_model['parent_acct'] + result;
    //             }
    //             else
    //               this.customer_model['acct_number'] = String(Number(result) + 1);
    //           }
    //           console.log(this.customer_model['acct_number']);

    //           values = [];
    //           console.log(element);

    //           this.customer_model['customer_name'] = element[0];
    //           this.customer_model['customer_name_en'] = element[1];
    //           this.customer_model['customer_last_name'] = element[2];
    //           this.customer_model['mobile'] = element[3];
    //           this.customer_model['national_id'] = element[6];
    //           this.customer_model['city_id'] = '1';
    //           values.push(this.customer_model);

    //           this.traveler_model['date_of_birth'] = (element[4] != '' ? element[4] : '1990-01-01');
    //           this.traveler_model['gender'] = (element[5] != '' ? element[5] : 'm');
    //           this.traveler_model['passport_no'] = element[6];
    //           this.traveler_model['passport_expiry_date'] = element[7];
    //           this.traveler_model['acct_number'] = this.customer_model['acct_number'];
    //           this.traveler_model['passport_issue_date'] = (new Date().getFullYear() + '-' +
    //             (new Date().getMonth() + 1) + '-' + new Date().getDate());
    //           this.traveler_model['nationality'] = '1';
    //           values.push(this.traveler_model);

    //           // sub acct data
    //           this.sub_acct_model['sub_acct_name'] = this.customer_model['customer_name'];
    //           this.sub_acct_model['sub_acct_name_en'] = this.customer_model['customer_name_en'] + " " + 
    //             this.customer_model['customer_last_name'];
    //           this.sub_acct_model['acct_number'] = this.customer_model['acct_number'];

    //           values.push(this.sub_acct_model);

    //           //add acct base
    //           this.base_model['base_date'] = new Date().getFullYear() + '-01-01 00:00:00';
    //           this.base_model['acct_number'] = this.customer_model['acct_number'];
    //           values.push(this.base_model);

    //           // calculate age
    //           birthdate = new Date(this.traveler_model['date_of_birth']);
    //           arrivaldate;

    //           if (this.return_flight['flight_id'] != '')
    //             arrivaldate = new Date(this.return_flight['flight_date']);
    //           else 
    //             arrivaldate = new Date(this.invoice_detail['flight_date']);
              
    //           timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());
    //           this.group_model['member_age'] = String(Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25));

    //           values.push({
    //             'table_name': 'trip_group', 'group_id': '0', 'invoice_no': this.invoice_detail['invoice_no'],
    //             'head_id': this.agent_detail['acct_number'], 'member_id': this.customer_model['acct_number'],
    //             'member_head_relation': '', 'is_active': '1', 'group_type': '',
    //             'trip_depart_date': this.invoice_detail['flight_date'], 'member_age': this.group_model['member_age'], 
    //             'eticket': '', 'ticket_status': '0', 'ticket_count': '1', 'bed_count': '0',
    //             'price': '0', 'flag': 'new', 'key': 'group_id', 'room_type_id': '0', 'comment': '',
    //             'visa_price': '0', 'food_price': '0'
    //           });

    //           if (this.return_flight['flight_id'] != '')
    //             values[values.length - 1]['trip_arrival_date'] = this.return_flight['flight_date'];

    //           console.log(values);
    //           obj = { cmd: 'add', values: values };

    //           this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //             .subscribe(data => {
    //               this.applicationConstants.appComp.hideBusyCursor();
          
    //               if (data.status['type'] == 'success') {
    //                 index++;
    //                 if (index == this.traveler_list.length) {
    //                   alert(this.Success_Msg);
    //                   this.router.navigate(['sub_menu/13/tour_invoice_list']);
    //                 }
    //               }
    //               else {
    //                 alert(this.Error_Msg);
    //                 this.saveClicked = false;
    //               }
    //             });
    //         });
    //     }
    //     else {
    //       let travelerInfo = data.data['list'][0];
          
    //       alert(this.Trav_Exist_Msg + ", " + this.Traveler_No + ": " + travelerInfo.acct_number + ", " + 
    //         this.Mobile + ": " + travelerInfo.mobile);

    //       this.saveClicked = false;
    //       return;
    //     }
    //   });
    // });

    // for (let index = 1; index < this.traveler_list.length; index++) {
      
    //   date_of_birth = (this.traveler_list[index][4] != '' ? this.traveler_list[index][4] : '1990-01-01');

    //   query = "SELECT `traveler_info`.`acct_number`, `customer`.`mobile` FROM `traveler_info`, `customer` " + 
    //     "WHERE `traveler_info`.`status` = '1' AND `traveler_info`.`date_of_birth` = '" + 
    //     date_of_birth + "' AND `traveler_info`.`passport_no` = '" + 
    //     this.traveler_list[index][6] + "' AND `traveler_info`.`acct_number` = `customer`.`acct_number`";
    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();

    //     if (data.data['list'].length == 0) {
    //       // add the traveler

    //       // generate acct number for traveler
    //       query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
    //         this.sub_acct_model['parent_acct'] + "'";
    //       obj = { cmd: 'getList', query: query };

    //       this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //         .subscribe(data => {
    //           this.applicationConstants.appComp.hideBusyCursor();

    //           let result = data.data['list'][0]['acct_number'];
    //           if (result == '0')
    //             this.customer_model['acct_number'] = this.sub_acct_model['parent_acct'] + "001";
    //           else {
    //             if (result.indexOf(this.sub_acct_model['parent_acct']) != -1) {
    //               result = result.substring(result.indexOf(this.sub_acct_model['parent_acct']) + (this.sub_acct_model['parent_acct']).length);
    //               console.log('result: ' + result);
    //               result = String(Number(result) + 1);
    //               if (Number(result) < 10)
    //                 result = '00' + result;
    //               else if (Number(result) < 100)
    //                 result = '0' + result;

    //               this.customer_model['acct_number'] = this.sub_acct_model['parent_acct'] + result;
    //             }
    //             else
    //               this.customer_model['acct_number'] = String(Number(result) + 1);
    //           }
    //           console.log(this.customer_model['acct_number']);

    //           values = [];

    //           element = this.traveler_list[index];
    //           console.log(element);

    //           this.customer_model['customer_name'] = element[0];
    //           this.customer_model['customer_name_en'] = element[1];
    //           this.customer_model['customer_last_name'] = element[2];
    //           this.customer_model['mobile'] = element[3];
    //           this.customer_model['national_id'] = element[6];
    //           this.customer_model['city_id'] = '1';
    //           values.push(this.customer_model);

    //           this.traveler_model['date_of_birth'] = (element[4] != '' ? element[4] : '1990-01-01');
    //           this.traveler_model['gender'] = (element[5] != '' ? element[5] : 'm');
    //           this.traveler_model['passport_no'] = element[6];
    //           this.traveler_model['passport_expiry_date'] = element[7];
    //           this.traveler_model['acct_number'] = this.customer_model['acct_number'];
    //           this.traveler_model['passport_issue_date'] = (new Date().getFullYear() + '-' +
    //             (new Date().getMonth() + 1) + '-' + new Date().getDate());
    //           this.traveler_model['nationality'] = '1';
    //           values.push(this.traveler_model);

    //           // sub acct data
    //           this.sub_acct_model['sub_acct_name'] = this.customer_model['customer_name'];
    //           this.sub_acct_model['sub_acct_name_en'] = this.customer_model['customer_name_en'] + " " + 
    //             this.customer_model['customer_last_name'];
    //           this.sub_acct_model['acct_number'] = this.customer_model['acct_number'];

    //           values.push(this.sub_acct_model);

    //           //add acct base
    //           this.base_model['base_date'] = new Date().getFullYear() + '-01-01 00:00:00';
    //           this.base_model['acct_number'] = this.customer_model['acct_number'];
    //           values.push(this.base_model);

    //           // calculate age
    //           birthdate = new Date(this.traveler_model['date_of_birth']);
    //           arrivaldate;

    //           if (this.return_flight['flight_id'] != '')
    //             arrivaldate = new Date(this.return_flight['flight_date']);
    //           else 
    //             arrivaldate = new Date(this.invoice_detail['flight_date']);
              
    //           timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());
    //           this.group_model['member_age'] = String(Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25));

    //           values.push({
    //             'table_name': 'trip_group', 'group_id': '0', 'invoice_no': this.invoice_detail['invoice_no'],
    //             'head_id': this.agent_detail['acct_number'], 'member_id': this.customer_model['acct_number'],
    //             'member_head_relation': '', 'is_active': '1', 'group_type': '',
    //             'trip_depart_date': this.invoice_detail['flight_date'], 'member_age': this.group_model['member_age'], 
    //             'eticket': '', 'ticket_status': '0', 'ticket_count': '1', 'bed_count': '0',
    //             'price': '0', 'flag': 'new', 'key': 'group_id', 'room_type_id': '0', 'comment': '',
    //             'visa_price': '0', 'food_price': '0'
    //           });

    //           if (this.return_flight['flight_id'] != '')
    //             values[values.length - 1]['trip_arrival_date'] = this.return_flight['flight_date'];

    //           console.log(values);
    //           obj = { cmd: 'add', values: values };

    //           this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //             .subscribe(data => {
    //               this.applicationConstants.appComp.hideBusyCursor();
          
    //               if (data.status['type'] == 'success') {
    //                 if (index + 1 == this.traveler_list.length) {
    //                   alert(this.Success_Msg);
    //                   this.router.navigate(['sub_menu/13/tour_invoice_list']);
    //                 }
    //               }
    //               else {
    //                 alert(this.Error_Msg);
    //                 this.saveClicked = false;
    //               }
    //             });
    //         });
    //     }
    //     else {
    //       let travelerInfo = data.data['list'][0];
          
    //       alert(this.Trav_Exist_Msg + ", " + this.Traveler_No + ": " + travelerInfo.acct_number + ", " + 
    //         this.Mobile + ": " + travelerInfo.mobile);

    //       index = this.traveler_list.length;
    //       this.saveClicked = false;
    //     }
    //   });
    // }
  }

  saveTraveler() {
    let query, obj;
    let values = [];
    let element;
    let acct_number, date_of_birth, birthdate, arrivaldate, timeDiff;

    // Arabic Name: 0, English Name: 1, Last Name: 2, Mobile No.: 3, DOB: 4, Gender: 5, 
    // Passport No.: 6, Passport Expiry Date: 7

    // generate acct number for traveler
    query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
      this.sub_acct_model['parent_acct'] + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        let result = data.data['list'][0]['acct_number'];
        if (result != '0') {
          if (result.indexOf(this.sub_acct_model['parent_acct']) != -1)
            result = result.substring(result.indexOf(this.sub_acct_model['parent_acct']) + (this.sub_acct_model['parent_acct']).length);
        }

        for (let index = 1; index < this.traveler_list.length; index++) {
          element = this.traveler_list[index];

          result = String(Number(result) + 1);
          if (Number(result) < 10)
            result = '00' + result;
          else if (Number(result) < 100)
            result = '0' + result;

            acct_number = this.sub_acct_model['parent_acct'] + result;

          // customer data
          values.push({
            'table_name': 'customer', 'customer_id': '0', 'customer_name': element[0], 
            'customer_name_en': element[1], 'customer_last_name': element[2], 
            'acct_number': acct_number, 'national_id': element[6], 
            'customer_category_id': '0', 'tax_no': '', 'city_id': '1', 'address': '', 
            'mobile': element[3], 'phone1': '', 'phone2': '', 'fax': '', 
            'email': '', 'represent1': '', 'represent1_mobile': '', 'represent2': '',
            'represent2_mobile': '', 'def_rep_no': '0', 'claim_day': 0, 'comment': '', 'car_type': '',
            'key': 'customer_id', 'flag': 'new', 'car_model': '', 'car_color': '', 'is_account': '1',
            'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'customer_cr': '',
            'agent_acct_number': this.agent_detail['acct_number']
          });

          // traveler data
          date_of_birth = (element[4] != '' ? element[4] : '1990-01-01');

          values.push({
            'table_name': 'traveler_info', 'info_id': '0', 'acct_number': acct_number, 
            'date_of_birth': date_of_birth, 'gender': element[5], 'occupation': '', 'passport_no':  element[6], 
            'passport_issue_date':  (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + 
            '-' + new Date().getDate()), 'passport_issue_location': '', 'key': 'info_id', 'flag': 'new', 
            'passport_expiry_date': element[7], 'smoker': 'false', 'medical_care': 'false', 'nationality': '1', 
            'passport_type': '', 'passport_attach': '', 'comment': '', 'reference': ''
          });

          // sub acct data
          values.push({
            'table_name': 'sub_acct', 'sub_acct_id': '0', 'sub_acct_name': element[0],
            'acct_type_no': this.applicationConstants.acct_type_config['customer'],
            'main_acct_no': this.applicationConstants.main_acct_config['customer'], 
            'sub_acct_name_en': element[1] + " " + element[2], 
            'acct_number': acct_number, 'parent_acct': this.sub_acct_model['parent_acct'],
            'acct_level': '1', 'is_leaf': '1', 'is_cc': '1', 'tax_acct': '0', 'emp_no': '0', 'cc_no': '0',
            'key': 'sub_acct_id', 'flag': 'new', 'comment': '', 'auto_set': '0', 'set_type': 'count'
          });

          //add acct base
          values.push({
            'table_name': 'acct_base', 'baseline_id': '0', 
            'base_date': new Date().getFullYear() + '-01-01 00:00:00', 
            'acct_number': acct_number,
            'main_acct_no': this.applicationConstants.main_acct_config['customer'],
            'acct_type_no': this.applicationConstants.acct_type_config['customer'], 'key': 'baseline_id',
            'flag': 'new', 'baseline_amount': '0', 'comment': ''
          });

          // calculate age
          birthdate = new Date(date_of_birth);
          arrivaldate;

          if (this.return_flight['flight_id'] != '')
            arrivaldate = new Date(this.return_flight['flight_date']);
          else 
            arrivaldate = new Date(this.invoice_detail['flight_date']);
          
          timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());
          this.group_model['member_age'] = String(Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25));

          values.push({
            'table_name': 'trip_group', 'group_id': '0', 'invoice_no': this.invoice_detail['invoice_no'],
            'head_id': this.agent_detail['acct_number'], 'member_id': acct_number,
            'member_head_relation': '', 'is_active': '1', 'group_type': '',
            'trip_depart_date': this.invoice_detail['flight_date'], 'member_age': this.group_model['member_age'], 
            'eticket': '', 'ticket_status': '0', 'ticket_count': '1', 'bed_count': '0',
            'price': '0', 'flag': 'new', 'key': 'group_id', 'room_type_id': '0', 'comment': '',
            'visa_price': '0', 'food_price': '0'
          });

          if (this.return_flight['flight_id'] != '')
            values[values.length - 1]['trip_arrival_date'] = this.return_flight['flight_date'];

          if ((index + 1) == this.traveler_list.length) {
            obj = { cmd: 'add', values: values };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.router.navigate(['sub_menu/13/tour_invoice_list']);
                }
                else {
                  alert(this.Error_Msg);
                  this.saveClicked = false;
                }
              });
          }
        }
      });
  }

}
